import React from "react";
import proImg1 from "../Assets/projectImg1.webp";
import proImg2 from "../Assets/projectImg2.webp";
import proImg3 from "../Assets/projectImg3.webp";
import proImg4 from "../Assets/projectImg4.webp";
import proImg5 from "../Assets/projectImg5.webp";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/pagination";

import { Pagination } from "swiper/modules";

export default function CommonProject() {
  return (
    <>
      <div className="projectSection">
        <div className="topSection">
          <h3>FEATURED WORKS</h3>
          <h1>PROJECTS YOU MAY LOVE</h1>
        </div>
        <div className="bottomSection">
          <Swiper

          style={{
            "--swiper-pagination-color": "#eb3656",
            "--swiper-pagination-bullet-inactive-color": "rgba(235,54,86,.7)",
            "--swiper-pagination-bullet-inactive-opacity": "1",
            "--swiper-pagination-bullet-size": "2.4rem",
            // "--swiper-pagination-bullet-horizontal-gap": "6px"
          }}

            slidesPerView={5}
            spaceBetween={28}
            breakpoints={{

              0: {
                slidesPerView: 1,
                // spaceBetween: 20,
              },
              576: {
                slidesPerView: 2,
                spaceBetween: 18,
              },
              767: {
                slidesPerView: 3,
                spaceBetween: 18,
              },
              992: {
                slidesPerView: 5,
                spaceBetween: 28,
              },
            }}
            loop={true}
            pagination={{
              dynamicBullets: true,
              clickable: true,
            }}
            modules={[Pagination]}
            className="mySwiper"
          >
            <SwiperSlide className="mySlide"><img src={proImg1} alt="img" /> <div className="magicTitle">Home Interior Design</div></SwiperSlide>
            <SwiperSlide className="mySlide"><img src={proImg2} alt="img" /> <div className="magicTitle">Home Interior Design</div></SwiperSlide>
            <SwiperSlide className="mySlide"><img src={proImg3} alt="img" /> <div className="magicTitle">Home Interior Design</div></SwiperSlide>
            <SwiperSlide className="mySlide"><img src={proImg4} alt="img" /> <div className="magicTitle">Home Interior Design</div></SwiperSlide>
            <SwiperSlide className="mySlide"><img src={proImg5} alt="img" /> <div className="magicTitle">Home Interior Design</div></SwiperSlide>
            <SwiperSlide className="mySlide"><img src={proImg3} alt="img" /> <div className="magicTitle">Home Interior Design</div></SwiperSlide>
            <SwiperSlide className="mySlide"><img src={proImg1} alt="img" /> <div className="magicTitle">Home Interior Design</div></SwiperSlide>
            <SwiperSlide className="mySlide"><img src={proImg4} alt="img" /> <div className="magicTitle">Home Interior Design</div></SwiperSlide>
            <SwiperSlide className="mySlide"><img src={proImg2} alt="img" /> <div className="magicTitle">Home Interior Design</div></SwiperSlide>
            <SwiperSlide className="mySlide"><img src={proImg5} alt="img" /> <div className="magicTitle">Home Interior Design</div></SwiperSlide>
            <SwiperSlide className="mySlide"><img src={proImg1} alt="img" /> <div className="magicTitle">Home Interior Design</div></SwiperSlide>
            <SwiperSlide className="mySlide"><img src={proImg3} alt="img" /> <div className="magicTitle">Home Interior Design</div></SwiperSlide>
            <SwiperSlide className="mySlide"><img src={proImg4} alt="img" /> <div className="magicTitle">Home Interior Design</div></SwiperSlide>
            <SwiperSlide className="mySlide"><img src={proImg2} alt="img" /> <div className="magicTitle">Home Interior Design</div></SwiperSlide>
            <SwiperSlide className="mySlide"><img src={proImg5} alt="img" /> <div className="magicTitle">Home Interior Design</div></SwiperSlide>
          </Swiper>
        </div>
      </div>
    </>
  );
}
